import React, {createContext, useReducer} from 'react'

export const SET_CIRCUIT_DATA = 'SET_CIRCUIT_DATA'
export const UPDATE_CHANGE_CIRCUIT_DATA = 'UPDATE_CHANGE_CIRCUIT_DATA'
export const SET_SELECTED_CIRCUIT_DATA = 'SET_SELECTED_CIRCUIT_DATA'
export const SET_SHOW_HIDE_CIRCUIT_POPUP = 'SET_SHOW_HIDE_CIRCUIT_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_CIRCUIT_DATA: {
      return {...data, data: payload.data}
    }
    case UPDATE_CHANGE_CIRCUIT_DATA: {
      let tempData = [...data.data.results]
      tempData[payload.data.index] = payload.data
      return {
        ...data,
        data: {...data.data, results: tempData},
        showCircuitFormPopup: false,
        selectedObject: {},
      }
    }
    case SET_SELECTED_CIRCUIT_DATA: {
      return {
        ...data,
        selectedObject: payload.data,
        showCircuitFormPopup: true,
      }
    }
    case SET_SHOW_HIDE_CIRCUIT_POPUP: {
      if (payload.data) {
        return {...data, showCircuitFormPopup: payload.data}
      }
      return {
        ...data,
        showCircuitFormPopup: payload.data,
        selectedObject: {},
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: {results: [], pagination: {}},
  selectedObject: {},
  showCircuitFormPopup: false,
}

const CircuitStore = ({children}) => {
  const [state, dispatch] = useReducer(Reducer, initialState)
  return (
    <CircuitContext.Provider value={[state, dispatch]}>
      {children}
    </CircuitContext.Provider>
  )
}

export const CircuitContext = createContext(initialState)
export default CircuitStore
